import axios from "axios";
import { PagedResult } from "../models/paged-result";
import { ProfesionalCreateModel } from "../models/profesional-create";
import { ProfesionalFicha, ProfesionalFichaUpdate } from "../models/profesional-ficha";
import { ProfesionalPerfil } from "../models/profesional-perfil";
import {
  ProfesionalResetPasswordRequest,
  ProfesionalResetPasswordResponse,
} from "../models/profesional-reset-password";
import { ProfesionalStatus } from "../models/profesional-status";

export const PROFESIONAL_URL = `Profesional`;

export const profesionalServices = {
  lookup: (queryParams: any) => {
    return axios.get<any>(`${PROFESIONAL_URL}/Lookup`, {
      params: { ...queryParams },
    });
  },

  activos: () => {
    return axios.get<any>(`${PROFESIONAL_URL}/Activos`);
  },

  getPerfil: (id: string) => {
    return axios.get<ProfesionalPerfil>(`${PROFESIONAL_URL}/${id}/Perfil`);
  },

  updatePerfil: (
    id: string,
    data: Omit<
      ProfesionalPerfil,
      "id" | "nombre" | "apellido" | "matriculaProf"
    >
  ) => {
    return axios.put(`${PROFESIONAL_URL}/${id}/Perfil`, data);
  },

  // Administración (solo ADMIN) — ver docs/API-PROFESIONALES-ADMIN.md
  getList: (queryParams: any) => {
    return axios.get<PagedResult>(`${PROFESIONAL_URL}`, {
      params: queryParams,
    });
  },

  create: (data: ProfesionalCreateModel) => {
    return axios.post<ProfesionalFicha>(`${PROFESIONAL_URL}`, data);
  },

  getFicha: (id: string) => {
    return axios.get<ProfesionalFicha>(`${PROFESIONAL_URL}/${id}/Ficha`);
  },

  updateFicha: (id: string, data: ProfesionalFichaUpdate) => {
    return axios.put<ProfesionalFicha>(`${PROFESIONAL_URL}/${id}/Ficha`, data);
  },

  activar: (id: string, observacion?: string) => {
    return axios.put<ProfesionalStatus>(`${PROFESIONAL_URL}/${id}/Activar`, {
      observacion,
    });
  },

  desactivar: (id: string, observacion?: string) => {
    return axios.put<ProfesionalStatus>(
      `${PROFESIONAL_URL}/${id}/Desactivar`,
      { observacion }
    );
  },

  resetPassword: (id: string, data: ProfesionalResetPasswordRequest) => {
    return axios.put<ProfesionalResetPasswordResponse>(
      `${PROFESIONAL_URL}/${id}/reset-password`,
      data
    );
  },
};
